import { useEffect, useState } from "react";
import axios from "axios";
import { GALLERY_FILTERS, galleryImageUrl } from "../config/photos";
import { PlaceholderBadge } from "../components/site/Blocks";

const Galerie = () => {
    const [filter, setFilter] = useState("Alle");
    const [images, setImages] = useState(null);

    useEffect(() => {
        axios
            .get("/api/public/gallery")
            .then((response) => setImages(response.data))
            .catch(() => setImages([]));
    }, []);

    const photos = (images || []).filter((photo) => filter === "Alle" || photo.tag === filter);

    return (
        <>
            <section className="sec page-head grid-2 !items-end pb-[72px]">
                <div className="eyebrow hero-in" style={{ animationDelay: ".1s" }}>
                    Galerie
                </div>
                <div className="hero-in" style={{ animationDelay: ".25s" }}>
                    <h1 className="h1-page mb-5">Aus Küche und Gastraum</h1>
                    {images && images.length > 0 && (
                        <div role="group" aria-label="Filter" className="flex flex-wrap gap-6">
                            {GALLERY_FILTERS.map((label) => {
                                const active = label === filter;
                                return (
                                    <button
                                        key={label}
                                        type="button"
                                        aria-pressed={active}
                                        onClick={() => setFilter(label)}
                                        className={`border-b bg-transparent pb-1.5 text-sm font-medium uppercase tracking-[.08em] ${
                                            active ? "border-forest text-forest" : "border-transparent text-forest/70"
                                        }`}
                                    >
                                        {label}
                                    </button>
                                );
                            })}
                        </div>
                    )}
                </div>
            </section>

            {images && photos.length === 0 && (
                <p className="sec body-text pb-[140px]">
                    {images.length === 0 ? "Fotos folgen in Kürze." : "In dieser Kategorie gibt es noch keine Fotos."}
                </p>
            )}

            <section aria-label="Bilder" className="sec columns-2 desk:columns-3 xwide:columns-4 gap-5 pb-[140px]">
                {photos.map((photo) => (
                    <figure key={photo._id} className="m-0 mb-5 break-inside-avoid">
                        <div className="mask relative">
                            {photo.placeholder && <PlaceholderBadge />}
                            <img
                                src={galleryImageUrl(photo)}
                                alt={photo.caption || "Foto aus dem Restaurant"}
                                loading="lazy"
                                width={photo.width}
                                height={photo.height}
                                className="block h-auto w-full"
                            />
                        </div>
                        {(photo.caption || photo.tag) && (
                            <figcaption className="mt-2.5 flex justify-between gap-3 text-sm text-forest/70">
                                <span className="font-caslon text-base text-forest">{photo.caption}</span>
                                <span>{photo.tag}</span>
                            </figcaption>
                        )}
                    </figure>
                ))}
            </section>
        </>
    );
};

export default Galerie;
